/**
 * Display order for our own generators wherever a list is "latest trends"
 * (homepage spotlight, header menu, footer column): newest `publishedAt`
 * first, ties keep registry order (`siteConfig.aiTools`).
 */

import type { AiToolBase } from '@/config/ai-tools/types';

type Dated = Pick<AiToolBase, 'publishedAt'>;

export function newestFirst<T extends Dated>(tools: readonly T[]): T[] {
  return tools
    .map((tool, index) => ({ tool, index }))
    .sort(
      (a, b) =>
        (Date.parse(b.tool.publishedAt) || 0) - (Date.parse(a.tool.publishedAt) || 0) || a.index - b.index,
    )
    .map((entry) => entry.tool);
}

/** The `limit` newest generators (header menus show 4, the footer 8). */
export function latestNativeTools<T extends Dated>(tools: readonly T[], limit: number): T[] {
  return newestFirst(tools).slice(0, Math.max(0, limit));
}
